const gettersBRRR = {
	ConstructionLoan(state) {
		if (
			state.result['home_price']
			&& state.result['construction_loan_downpayment']
		) {
			let per = (1 / 100 * +state.result['construction_loan_downpayment']);
			return (1 - per) * (+state.result['home_price'] + +state.result['repairs'] + +state.result['home_inspection'] + +state.result['updates']);
		}
		return 0;
	},
	ConstructionLoanDownpayment(state) {
		if (
			state.result['home_price']
			&& state.result['construction_loan_downpayment']
		) {
			return +state.result['construction_loan_downpayment'] / 100 * (+state.result['home_price'] + +state.result['repairs'] + +state.result['home_inspection'] + +state.result['updates']);
		}
		return 0;
	},
	AcquisitionAndConstruction(state, getters) {
		return getters.ConstructionLoan + getters.ConstructionLoanDownpayment;
	},
	ConstructionLoanClosingCosts(state, getters) {
		return +state.result['construction_loan_closing_costs'] / 100 * getters.ConstructionLoan;
	},
	ConstructionLoanInterest(state, getters) {
		return getters.ConstructionLoan * (+state.result['construction_loan_interest_rate'] / 100) * +state.result['month_until_refinance'] / 12;
	},
	InitialMoneyInDPClosingInterest(state, getters) {
		return getters.ConstructionLoanDownpayment + getters.ConstructionLoanClosingCosts + getters.ConstructionLoanInterest;
	},

	AfterRepairValue(state) {
		return +state.result['after_repair_value'];
	},
	NewLoanAtLTV(state) {
		return (1 - +state.result['downpayment'] / 100) * +state.result['after_repair_value'];
	},
	MinusConstructionLoan(state, getters) {
		return getters.ConstructionLoan * -1;
	},
	CashOutRefiCheck(state, getters) {
		return getters.NewLoanAtLTV + getters.MinusConstructionLoan;
	},
	MinusInitialMoneyIn(state, getters) {
		return getters.InitialMoneyInDPClosingInterest * -1;
	},
	CashInMinusOrCashOutPlus(state, getters) {
		return getters.CashOutRefiCheck + getters.MinusInitialMoneyIn;
	},
	NewEquityAfterRefinance(state, getters) {
		return +state.result['after_repair_value'] - (+state.result['home_price'] + +state.result['repairs'] + +state.result['home_inspection'] + +state.result['updates']);
	},
	Rents(state, getters) {
		return +getters.TotalRevenues;
	},
	PrincipalInterest(state, getters) {
		return +getters.MonthlyPayment * -1;
	},
	MonthlyTaxes(state, getters) {
		return +getters.EscrowTaxes * -1;
	},
	MonthlyInsurance(state, getters) {
		return (+state.result['escrow_hazard_insurance'] + +state.result['escrow_homeowners_insurance']) * -1;
	},
	MonthlyOperatingExpenses(state, getters) {
		return +getters.TotalOperatingExpensesCosts * -1;
	},
	MonthlyCashFlow(state, getters) {
		return +getters.Rents + +getters.PrincipalInterest + +getters.MonthlyTaxes + +getters.MonthlyInsurance + +getters.MonthlyOperatingExpenses;
	},
	CashOnCashReturn(state, getters) {
		return (+getters.MonthlyCashFlow * 12 / (+getters.CashInMinusOrCashOutPlus * -1)) * 100;
	},
};

export { gettersBRRR };
